// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-menu-box[data-v-48c1bc4f]{align-items:center;display:flex;font-size:16px}.main-menu-box .item-menu[data-v-48c1bc4f]{color:#212121;margin-left:30px}.main-menu-box .active[data-v-48c1bc4f],.main-menu-box .item-menu[data-v-48c1bc4f]:hover{color:#1890ff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
